import { useContext } from "react"
import { useQuery, useMutation } from "@apollo/client"
import { Link, useParams, useNavigate } from "react-router-dom"
import { LoaderMedium } from "../../../../components/Loaders"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { trimTextValue } from "../../../../components/FieldTypes/helpers/trimTextValue"

// Context
import { UserContext } from "../../../../context/userContext"

// Prime
import { InputText as Input } from "primereact/inputtext"
import { Button } from "primereact/button"
import { ToggleButton } from "primereact/togglebutton"

// Styles
import styles from "../../../../styles/Form.module.css"

import { EDIT_BLOCK, GET_PARENT_BLOCK, GET_BLOCKS_LIBRARY } from "../../queries"
import AssessmentBlock from "../../../Assessments/AssessmentBlock/AssessmentBlock"

export default function AssessmentEdit() {
  // const [loading, setLoading] = useState(true)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const [editBlock] = useMutation(EDIT_BLOCK)

  const { idBlock } = useParams()

  const { data, loading } = useQuery(GET_PARENT_BLOCK, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      enterprise_id: userCtx.session.user.enterprise_id,
      idBlock: idBlock,
      type: "custom",
    },
    fetchPolicy: "network-only",
  })

  if (loading) return <LoaderMedium />

  const newBlock = Yup.object().shape({
    block_title: Yup.string(),
  })

  return (
    <div>
      <h1>Customize Assessment Block</h1>
      <br />
      <Link
        to="/library/blocks"
        style={{ marginBottom: 30, display: "inline-block" }}
        className="btn"
      >
        Back to Library
      </Link>
      <Formik
        initialValues={{
          block_name: data.currentBlock.block_name,
          block_title: data.currentBlock.block_title,
          data_propogation:
            data.currentBlock.configuration.behavior.data_propagation,
          block_required: data.currentBlock.configuration.system_required,
          assessments: data.currentBlock.configuration.rules.assessments,
        }}
        validationSchema={newBlock}
        onSubmit={async (values) => {
          let assessmentValue = values.assessments
            ? values.assessments.map((assessment) => {
                return {
                  assessment_id: assessment.assessment_id,
                  required: assessment.required,
                }
              })
            : []
          await editBlock({
            variables: {
              idBlock,
              organization_id: userCtx.session.user.organization_id,
              enterprise_id: userCtx.session.user.enterprise_id,
              updated_by: userCtx.session.user.staff_id,
              fields: JSON.stringify([
                {
                  idField: "assessments",
                  field_name: "assessment",
                },
              ]),
              block_name: values.block_name,
              block_title: values.block_title,
              configuration: JSON.stringify({
                allow_custom_config: false,
                behavior: {
                  data_propagation: false,
                },
                rules: {
                  programs: [],
                  assessments: assessmentValue,
                },
                system_required: values.block_required,
              }),
            },
            refetchQueries: [
              {
                query: GET_BLOCKS_LIBRARY,
                variables: {
                  staff_id: userCtx.session.user.staff_id,
                  organization_id: userCtx.session.user.organization_id,
                },
              },
            ],
          })
          navigate("/library/blocks")
        }}
      >
        {(formik) => {
          return (
            <Form className={styles.form}>
              <div className={styles.field}>
                <label className={styles.label}>Current Block Name:</label>
                <Input
                  name="block_name"
                  value={data.currentBlock.block_name}
                  disabled
                  className={styles.value}
                />
              </div>

              <div className={styles.field}>
                <label className={styles.label}>New Block Name:</label>
                <Input
                  name="block_title"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  value={formik.values.block_title}
                  className={styles.value}
                />
                {formik.touched.block_title && formik.errors.block_title && (
                  <div className={styles.errFieldMsg}>
                    {formik.errors.block_title}
                  </div>
                )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>Is required:</label>
                <ToggleButton
                  name="block_required"
                  checked={formik.values.block_required}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onIcon="pi pi-check"
                  offIcon="pi pi-times"
                  aria-label="block_required"
                  className={styles.value}
                />
              </div>

              <AssessmentBlock
                assessmentConfig={formik.values.assessments}
                onSubmitAssessments={(newAssessmentConfig) => {
                  formik.setFieldValue("assessments", newAssessmentConfig)
                }}
                adminMode={true}
              />

              <Button
                style={{ marginTop: 15 }}
                label="Submit"
                icon="pi pi-check"
                loading={formik.isSubmitting}
                disabled={!formik.isValid}
                type="submit"
                className={styles.btnSubmit}
              />
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
